var GLESConnector = /** @class */ (function () {
    function GLESConnector() {
    }
    Object.defineProperty(GLESConnector, "gles", {
        get: function () {
            if (!GLESConnector._gles)
                throw ('Error: Set GlesConnector.gles before calling methods on ContextGLES!');
            return GLESConnector._gles;
        },
        set: function (value) {
            GLESConnector._gles = value;
        },
        enumerable: true,
        configurable: true
    });
    GLESConnector._gles = null;
    return GLESConnector;
}());
export { GLESConnector };
